import { parseCurrency } from "../../../../helpers/StringManipulation";

const buildEditProductVariable = (
  { price, stock, selectedCategories, ...productInfoTabProps },
  product,
  hasVariants,
  acceptsDonations
) => {
  const ifDifferentAdd = (key) => {
    const variantValue = !productInfoTabProps[key]
      ? productInfoTabProps[key]
      : productInfoTabProps[key].trim();

    return (
      product[key] !== variantValue && {
        [key]: variantValue
      }
    );
  };

  const editedProductSKU = !hasVariants ? ifDifferentAdd("sku") : { sku: null };

  const editedProductPrice = getEditedProductPrice(
    hasVariants,
    acceptsDonations,
    product,
    price
  );

  const editedProductStock = getEditedProductStock(product, stock, hasVariants);

  const editedProductCategories = getEditedProductCategories(
    product,
    selectedCategories
  );

  return {
    id: product.id,
    ...ifDifferentAdd("name"),
    ...ifDifferentAdd("description"),
    ...editedProductSKU,
    ...editedProductPrice,
    ...editedProductStock,
    ...editedProductCategories,
    isDonation: acceptsDonations
  };
};

const getEditedProductStock = (product, stock, hasVariants) => {
  const stocksAreNotEqual =
    (product.stock !== null ? parseInt(product.stock) : product.stock) !==
    (!stock ? null : parseInt(stock));

  return !hasVariants
    ? stocksAreNotEqual && {
        stock: !stock ? null : parseInt(stock)
      }
    : { stock: null };
};

const getEditedProductPrice = (hasVariants, acceptsDonations, product, price) =>
  !hasVariants && !acceptsDonations
    ? parseCurrency(product.price) !== parseCurrency(price) && {
        price: parseCurrency(price)
      }
    : { price: null };

const getEditedProductCategories = (product, selectedCategories) =>
  (product.categories.length !== selectedCategories.length ||
    product.categories.filter(
      (category) =>
        !selectedCategories.map(({ id }) => id).includes(category.id)
    ).length) && { categories: selectedCategories.map(({ id }) => id) };

export default buildEditProductVariable;
